/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Priority_NoneInputs */

const en_priority_none = /** @type {(inputs: Priority_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No priority`)
};

const de_priority_none = /** @type {(inputs: Priority_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Priorität`)
};

/**
* | output |
* | --- |
* | "No priority" |
*
* @param {Priority_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const priority_none = /** @type {((inputs?: Priority_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Priority_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_priority_none(inputs)
	return en_priority_none(inputs)
});